import React, { FC } from 'react';

type Props = {
  data: Record<string, unknown>;
  testId?: string;
};

const Schema: FC<Props> = ({ data, testId }) => {
  const schemaJson = JSON.stringify({
    '@context': 'http://schema.org',
    ...data
  });

  const safeJson = schemaJson.replace(/<\/script/gi, '&lt;/script');

  return (
    <script
      type="application/ld+json"
      data-testid={testId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: safeJson
      }}
    />
  );
};

export default Schema;
